import React from 'react';
import {
  Box,
  Grid,
  HStack,
  Skeleton,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FiTarget } from 'react-icons/fi';
import { SaktiKpiTotals } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiKpiCardsProps {
  loading: boolean;
  totals: SaktiKpiTotals;
}

const formatCount = (value: number) => {
  return value.toLocaleString('id-ID');
};

const formatWeight = (value: number) => {
  return value.toLocaleString('id-ID', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

const SaktiKpiCards: React.FC<SaktiKpiCardsProps> = ({ loading, totals }) => {
  const cards = [
    {
      key: 'total-bcc',
      label: 'TOTAL BCC',
      value: formatCount(totals.total_bcc_cnt),
      unit: 'item',
    },
    {
      key: 'total-spb',
      label: 'TOTAL SPB',
      value: formatCount(totals.total_spb_cnt),
      unit: 'item',
    },
    {
      key: 'tonase',
      label: 'TONASE',
      value: formatWeight(totals.total_bcc_weight),
      unit: 'kg',
    },
    {
      key: 'restan',
      label: 'RESTAN',
      value: formatWeight(totals.total_restan_weight),
      unit: 'kg',
    },
  ];

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(4, 1fr)' }} gap={3}>
      {cards.map((card) => (
        <Skeleton key={card.key} isLoaded={!loading} borderRadius={SAKTI_UI_SIZE.cardRadius}>
          <Box
            bg="white"
            borderRadius={SAKTI_UI_SIZE.cardRadius}
            p={SAKTI_UI_SIZE.cardPadding}
            borderWidth="1px"
            borderColor="gray.200"
          >
            <VStack align="stretch" spacing={3}>
              <HStack justify="space-between" align="start">
                <Box
                  bg="green.50"
                  color="green.600"
                  borderRadius="md"
                  p={1.5}
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                  boxSize={SAKTI_UI_SIZE.kpiIconBoxSize}
                >
                  <FiTarget />
                </Box>
              </HStack>

              <Stat>
                <StatLabel
                  fontSize={SAKTI_UI_SIZE.kpiLabel}
                  letterSpacing="wider"
                  color="gray.500"
                >
                  {card.label}
                </StatLabel>
                <HStack align="end" spacing={1}>
                  <StatNumber fontSize={SAKTI_UI_SIZE.kpiValue}>{card.value}</StatNumber>
                  <Text color="gray.500" pb={1} fontSize="xs">
                    {card.unit}
                  </Text>
                </HStack>
              </Stat>
            </VStack>
          </Box>
        </Skeleton>
      ))}
    </Grid>
  );
};

export default SaktiKpiCards;
